import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw, ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/InfoSections";
import { useI18n } from "@/i18n";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-white">
      <Header minimal />
      <main className="rpm-grid-bg py-14 sm:py-20">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="rpm-card mx-4 p-7 sm:mx-auto sm:max-w-xl sm:p-9" data-testid="payment-cancel-card">
          <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--rpm-yellow)]">
            <RotateCcw className="h-7 w-7" />
          </span>
          <h1 className="font-display text-3xl font-bold tracking-tight" data-testid="payment-cancel-title">
            {t("cancel.title")}
          </h1>
          <p className="mt-3 text-zinc-700">{t("cancel.text")}</p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link to="/#checkout" className="rpm-btn rpm-btn-orange flex-1" data-testid="payment-cancel-back-to-order-button">
              {t("cancel.back")}
            </Link>
            <Link to="/" className="rpm-btn rpm-btn-outline flex-1" data-testid="payment-cancel-home-button">
              <ArrowLeft className="h-4 w-4" /> {t("cancel.home")}
            </Link>
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
